/**
 * @file jackpot-scene.js
 * @desc This module contains Jackpot Scene class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2017 (c) KSI Corporation
 * */

(/** @lends <global> */function (global) {
    'use strict';


    var Scene = require('scene').Scene;
    var Animation = require('animation').Animation;

    var getRandomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    var lamps_pos = [
        [117, 558],
        [117, 545],
        [117, 532],
        [117, 519],
        [117, 506],
        [117, 493],
        [117, 480],
        [117, 467],
        [117, 454],
        [117, 441],
        [117, 428],
        [117, 415],
        [117, 402],
        [117, 389],
        [117, 376],
        [117, 363],
        [117, 350],
        [117, 337],
        [117, 324],
        [117, 311],
        [117, 298],
        [117, 285],
        [117, 272],
        [117, 259],
        [117, 246],
        [117, 233],
        [117, 220],
        [117, 207],
        [117, 194],
        [117, 181],
        [117, 168],
        [117, 155],
        [120, 142],
        [128, 132],
        [140, 128],
        [153, 127],
        [166, 127],
        [179, 127],
        [192, 127],
        [205, 127],
        [212, 116],
        [219, 105],
        [228, 96],
        [237, 87],
        [247, 79],
        [257, 72],
        [268, 65],
        [279, 59],
        [289, 54],
        [300, 49],
        [311, 45],
        [322, 41],
        [333, 38],
        [344, 35],
        [356, 32],
        [368, 29],
        [380, 27],
        [393, 25],
        [405, 23],
        [418, 21],
        [431, 20],
        [444, 19],
        [456, 18],
        [470, 18],
        [483, 18],
        [496, 18],
        [509, 18],
        [522, 18],
        [535, 19],
        [548, 20],
        [561, 22],
        [574, 23],
        [587, 25],
        [600, 27],
        [613, 30],
        [626, 33],
        [638, 36],
        [650, 40],
        [662, 44],
        [674, 49],
        [686, 54],
        [697, 59],
        [708, 65],
        [719, 71],
        [729, 79],
        [739, 87],
        [749, 96],
        [758, 106],
        [765, 117],
        [772, 126],
        [785, 127],
        [798, 127],
        [811, 127],
        [825, 127],
        [838, 128],
        [850, 135],
        [857, 146],
        [859, 159],
        [859, 172],
        [859, 185],
        [859, 198],
        [859, 211],
        [859, 224],
        [859, 237],
        [859, 250],
        [859, 262],
        [859, 275],
        [859, 288],
        [859, 301],
        [859, 314],
        [859, 327],
        [859, 340],
        [859, 353],
        [859, 366],
        [859, 379],
        [859, 392],
        [859, 405],
        [859, 418],
        [859, 431],
        [859, 444],
        [859, 457],
        [859, 470],
        [859, 483],
        [859, 496],
        [859, 509],
        [859, 522],
        [859, 535],
        [859, 548],
        // [859, 561],
        // [856, 574],
        // [848, 584],
        // [836, 589],
        // [823, 589],
        // [810, 589],
        // [797, 589],
        // [784, 589],
        // [771, 589],
        // [758, 589],
        // [745, 589],
        // [732, 589],
        // [719, 589],
        // [706, 589],
        // [693, 589],
        // [681, 589],
        // [668, 589],
        // [655, 589],
        [642, 589],
        [630, 589],
        [617, 589],
        [604, 589],
        [591, 589],
        [578, 589],
        [565, 589],
        [552, 589],
        [539, 589],
        [526, 589],
        [513, 589],
        [500, 589],
        [487, 589],
        [474, 589],
        [461, 589],
        [448, 589],
        [435, 589],
        [422, 589],
        [409, 589],
        [396, 589],
        [383, 589],
        [370, 589],
        [357, 589],
        [344, 589],
        [331, 589],
        [318, 589],
        [305, 589],
        [292, 589],
        // [279, 589],
        // [266, 589],
        // [253, 589],
        // [240, 589],
        // [227, 589],
        // [214, 589],
        // [201, 589],
        // [188, 589],
        // [175, 589],
        // [162, 589],
        // [149, 589],
        // [136, 588],
        // [125, 582],
        // [118, 571]
    ];

    /**
     * Constructs JackpotScene object.
     * @class
     * @constructor
     * @name JackpotScene
     * @classdesc This is a complete fully configured GUI component.
     * @extends {Scene}
     * @requires Scene
     * */
    var JackpotScene = function (config) {
        Scene.call(this);

        // this.shadow = new PIXI.Sprite(PIXI.utils.TextureCache['res/jackpot/shadow.png']);
        // this.shadow.scale.x = 256;
        // this.shadow.scale.y = 192;
        // this.shadow.position.set(0, 0);
        // this.shadow.visible = true;
        // this.addChild(this.shadow);
    
        this.interactive = true;
        this.buttonMode = true;
        this.cursor = 'inherit';
    
        this.hitArea = new PIXI.Rectangle(0,0,1024,768);
        this.click = function () {
            console.log('click on jackpot screen');
            if (this.onClick) {
                this.onClick();
            }
        }.bind(this);
        
        this.lamps_texture = [];
        this.lamps_texture.push(PIXI.utils.TextureCache['res/common/jackpot/lamp/000.png']);
        this.lamps_texture.push(PIXI.utils.TextureCache['res/common/jackpot/lamp/001.png']);
        this.lamps_texture.push(PIXI.utils.TextureCache['res/common/jackpot/lamp/002.png']);
        this.lamps_texture.push(PIXI.utils.TextureCache['res/common/jackpot/lamp/003.png']);

        this.jackpotContainer = new PIXI.Container();
        this.jackpotContainer.position.set(0, -1024);
        this.addChild(this.jackpotContainer);

        this.tables = [];
        this.tables[0] = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/jackpot_table.jpg']);
        this.tables[1] = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/super_table.jpg']);
        this.tables[2] = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/mega_table.jpg']);
        for (var table = 0; table < this.tables.length; ++table) {
            this.tables[table].position.set(0, 0);
            this.jackpotContainer.addChild(this.tables[table]);
        }

        this.lamps = [];
        for (var i = 0; i < lamps_pos.length; ++i) {
            var lamp = new PIXI.Sprite();
            lamp.position.set(lamps_pos[i][0]/* - 86*/, lamps_pos[i][1]);
            // lamp.texture = this.lamps_texture[0];
            this.jackpotContainer.addChild(lamp);
            lamp.alpha = 0;
            lamp.visible = true;
            this.lamps.push(lamp);
        }

        this.winValueLabel = new PIXI.extras.BitmapText('0', {font: 'jackpot-font', align: 'left'});
        this.winValueLabel.anchor.set(1, 0);
        this.winValueLabel.position.set(772, 365);
        this.jackpotContainer.addChild(this.winValueLabel);
        this.winValueLabel.text = '';
        this.winValueLabel.visible = false;

        // this.animShine = Animation.byFrameName('jackpot_shine_%03d.png', 30);
        // this.animShine.position.set(139, 151);
        // this.animShine.animationSpeed = 0.35;
        // this.animShine.loop = true;
        // this.animShine.visible = true;
        // this.jackpotContainer.addChild(this.animShine);

        // this.animSuper = Animation.byFrameName('super_shine_%03d.png', 30);
        // this.animSuper.position.set(362, 67);
        // this.animSuper.animationSpeed = 0.35;
        // this.animSuper.loop = true;
        // this.animSuper.visible = false;
        // this.jackpotContainer.addChild(this.animSuper);

        // this.animMega = Animation.byFrameName('mega_shine_%03d.png', 30);
        // this.animMega.position.set(362, 67);
        // this.animMega.animationSpeed = 0.35;
        // this.animMega.loop = true;
        // this.animMega.visible = false;
        // this.jackpotContainer.addChild(this.animMega);

        this.top_persons = [];
        this.top_persons[0] = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/pers_top_left.png']);
        this.top_persons[0].position.set(103, 34);
        this.top_persons[0].visible = false;
        this.jackpotContainer.addChild(this.top_persons[0]);
        this.top_persons[1] = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/pers_top_right.png']);
        this.top_persons[1].position.set(731, 17);
        this.top_persons[1].visible = false;
        this.jackpotContainer.addChild(this.top_persons[1]);
        
        this.youWonLabel = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/you_won.png']);
        this.youWonLabel.anchor.set(0.5, 0);
        this.youWonLabel.position.set(512/* - 86*/, /*618*/490);
        this.jackpotContainer.addChild(this.youWonLabel);
        this.youWonLabel.alpha = 0;
        this.youWonLabel.visible = false;

        var bronzeCoins = [];
        var silverCoins = [];
        var goldCoins = [];
        for (var j = 0; j < 50; ++j) {
            var bronze_coin = Animation.byFrameName('bronze_coin_%03d.png', 10);
            var silver_coin = Animation.byFrameName('silver_coin_%03d.png', 10);
            var gold_coin = Animation.byFrameName('gold_coin_%03d.png', 10);
            var right = 586 * (j % 2);
            var x = getRandomInt(4 + right + 86, 204 + right + 86);
            var coins_speed = Math.random() * (0.35 - 0.05) + 0.05;
            bronze_coin.position.set(x, -50);
            bronze_coin.anchor.set(0.5, 0.5);
            bronze_coin.animationSpeed = coins_speed;
            bronze_coin.loop = true;
            silver_coin.position.set(x, -50);
            silver_coin.anchor.set(0.5, 0.5);
            silver_coin.animationSpeed = coins_speed;
            silver_coin.loop = true;
            gold_coin.position.set(x, -50);
            gold_coin.anchor.set(0.5, 0.5);
            gold_coin.animationSpeed = coins_speed;
            gold_coin.loop = true;
            this.jackpotContainer.addChild(bronze_coin);
            this.jackpotContainer.addChild(silver_coin);
            this.jackpotContainer.addChild(gold_coin);
            bronzeCoins.push(bronze_coin);
            silverCoins.push(silver_coin);
            goldCoins.push(gold_coin);
        }
        this.allCoins = [];
        this.allCoins[0] = bronzeCoins;
        this.allCoins[1] = silverCoins;
        this.allCoins[2] = goldCoins;

        this.persons = [];
        this.persons[0] = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/persones_bronze.png']);
        this.persons[0].position.set(0, 553);
        this.jackpotContainer.addChild(this.persons[0]);
        this.persons[1] = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/persones_silver.png']);
        this.persons[1].position.set(0, 379);
        this.jackpotContainer.addChild(this.persons[1]);
        this.persons[2] = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/persones_gold.png']);
        this.persons[2].position.set(0, 379);
        this.jackpotContainer.addChild(this.persons[2]);

        this.pressCollectLabel = new PIXI.Sprite(PIXI.utils.TextureCache['res/common/jackpot/press_collect.png']);
        this.pressCollectLabel.anchor.set(0.5, 0);
        this.pressCollectLabel.position.set(512/* - 86*/, 515);
        this.jackpotContainer.addChild(this.pressCollectLabel);
        this.pressCollectLabel.alpha = 0;
        this.pressCollectLabel.visible = false;

        this.winflow_ended = false;

        var scaleX = config.resolution.width / 1024,
            scaleY = config.resolution.height / 768;

        this.scale.set(scaleX, scaleY);

        this.visible = false;


        this.sndImpact = sounds.get('res/common/sounds/jackpot/impact');
        this.sndIntro = sounds.get('res/common/sounds/jackpot/intro');
        this.loopSounds = [];
        for (var s = 0; s < 3; ++s) {
            this.loopSounds[s] = sounds.get('res/common/sounds/jackpot/loop_%d'.$(s));
            this.loopSounds[s].loop(true);
        }
        this.sndCollect = sounds.get('res/common/sounds/jackpot/take');
    };

    JackpotScene.prototype = Object.create(Scene.prototype);

    JackpotScene.prototype.constructor = JackpotScene;
    
    JackpotScene.prototype.terminate = function () {
    
        this.removeChildren();
        this.destroy();
    
        this.click = null;
    
        this.lamps_texture = null;
    
        this.tables = null;
    
        this.lamps = null;
    
        this.winValueLabel = null;
    
        // this.animShine.destroy();
        // this.animShine = null;
        //
        // this.animSuper.destroy();
        // this.animSuper = null;
        //
        // this.animMega.destroy();
        // this.animMega = null;
    
        this.top_persons = null;
    
        this.youWonLabel = null;
    
        this.allCoins = null;
    
        this.persons = null;
    
        this.pressCollectLabel = null;
    
        this.sndImpact.stop();
        this.sndImpact = null;
    
        this.sndIntro.stop();
        this.sndIntro = null;
    
        this.loopSounds.forEach(function(sound) {
            sound.stop();
        });
        this.loopSounds = null;
    
        this.sndCollect.stop();
        this.sndCollect = null;
    
    };
    
    JackpotScene.prototype.show = function (type, flow_time, _from, _to, _done) {

        console.log('### JACKPOT SHOW TIME = ' + flow_time);

        var from = null, to, done;

        if (typeof _to === 'function') {
            to = _from;
            done = _to;
        }
        else if (typeof _done === 'function') {
            from = _from;
            to = _to;
            done = _done;
        }

        else if (_done === undefined) {
            throw new Error('SHOULD NOT BE HAPPENED');
            from = _from;
            to = _to;
            done = function () {

            };
        }

        var main_table = this.tables[type];
        var animCoins = this.allCoins[type];
        this.winValueLabel.visible = true;
        for (var j = 0; j < 3; ++j) {
            if (j === type) {
                this.tables[j].visible = true;
                this.allCoins[j].visible = true;
                this.persons[j].visible = true;
            }
            else {
                this.tables[j].visible = false;
                this.allCoins[j].visible = false;
                this.persons[j].visible = false;
            }
        }

        // var animMoreShine = null;
        // if (type === 1) {
        //     animMoreShine = this.animSuper;
        // }
        if (type === 2) {
            // animMoreShine = this.animMega;
            this.top_persons[0].visible = true;
            this.top_persons[1].visible = true;
        }

        var self = this;

        for (var i = 0; i < animCoins.length; ++i) {
            animCoins[i].position.y = -50;
        }
       
        this.visible = true;
        this.jackpotContainer.visible = true;
    
        var onFallDownComplete = function () {
            // this.animShine.gotoAndPlay(0);
            // if (animMoreShine !== null) {
            //     animMoreShine.visible = true;
            //     animMoreShine.gotoAndPlay(0);
            // }
        
            this.winflow_ended = false;
            this.showYouWonLabel();
        
            this.flowWinLabel(this.winValueLabel, flow_time, from, to, function () {
                self.winflow_ended = true;
            
                clearTimeout(sndLoopDelay);
            
                self.loopSounds[type].fade(1, 0, 2000);
            
                var fadeOutTween = new TWEEN.Tween(self.youWonLabel)
                    .to({alpha: 0}, 500)
                    .onComplete(function () {
                        self.youWonLabel.visible = false;
                        self.blinkPressStart();
                        if (done) {
                            done();
                        }
                    })
                    .start();
            });
            this.animLamps();
            this.coinsRain(605, animCoins);
        }.bind(this);


        // если джекпот должен набегать
        if (from !== null) {
            // то он должен сначала вывалиться из-за экрана
            this.sndImpact.play();
    
            setTimeout(function () {
                self.sndIntro.play();
            }, 1000);
    
            var sndLoopDelay = setTimeout(function () {
                self.loopSounds[type].volume(1);
                self.loopSounds[type].play();
            }, 5000);
            
            this.winValueLabel.text = from.toString();
            this.jackpotContainer.position.set(0, -1024);
            var fallDownTween = new TWEEN.Tween(this.jackpotContainer.position)
                .to({y: 0}, 500)
                .onComplete(onFallDownComplete)
                .start();
        }
        // если джекпот должен быть показан без набегания
        else {
            this.winValueLabel.text = to.toString();
            main_table.position.set(0, 0);
            this.jackpotContainer.position.set(0, 0);
            // this.animShine.play();
            // if (animMoreShine !== null) {
            //     animMoreShine.visible = true;
            //     animMoreShine.gotoAndPlay(0);
            // }

            this.winflow_ended = true;


            // показать финальное значение
            this.sndIntro.stop();
            this.loopSounds[type].stop();
            this.blinkPressStart();
            if (this.winflow_ended === false) {
                this.animLamps();
            }
            if (done) {
                done();
            }
        }
    };

    JackpotScene.prototype.hide = function (done) {
        this.visible = false;
        this.iterationCount = 0;
        this.winflow_ended = false;

        // this.animMega.visible = false;
        // this.animSuper.visible = false;

        this.top_persons[0].visible = false;
        this.top_persons[1].visible = false;

        if (this.snakeTimeId) clearTimeout(this.snakeTimeId);
        if (this.blinkFadeInTween) {
            this.blinkFadeInTween.stop();
            this.blinkFadeInTween = null;
        }
        if (this.blinkFadeOutTween) {
            this.blinkFadeOutTween.stop();
            this.blinkFadeOutTween = null;

        }
        if (this.trainsTimeId) clearTimeout(this.trainsTimeId);
        if (this.blinkTimeId) clearTimeout(this.blinkTimeId);

        for (var type = 0; type < 3; ++type) {
            for (var i = 0; i < this.allCoins[type].length; ++i) {
                if (this.fallDownTween && this.fallDownTween[i]) {
                    this.fallDownTween[i].stop();
                    this.fallDownTween[i] = null;
                }
                this.allCoins[type][i].gotoAndStop(0);
                this.allCoins[type][i].visible = false;
            }
            this.loopSounds[type].stop();
        }

        if (this.blinkTween) {
            this.blinkTween.stop();
            this.blinkTween = null;
        }
        for (var j = 0; j < this.lamps.length; ++j) {
            this.lamps[j].texture = null;
            this.lamps[j].alpha = 0;
            this.lamps[j].visible = false;
        }

        this.sndIntro.stop();

        this.sndCollect.on('end', function () {
            if (done) done();
        });

        this.sndCollect.play();

        this.pressCollectLabel.visible = false;
    };

    JackpotScene.prototype.animLamps = function () {

        var self = this;
        self.iterationCount = 0;

        var hideAllLamps = function () {
            for (var i = 0; i < self.lamps.length; ++i) {
                self.lamps[i].alpha = 0;
                self.lamps.texture = null;
                self.lamps[i].visible = false;
            }
        };

        var randomBlink = function (done) {
            var self = this;
            ++self.iterationCount;
            for (var i = 0; i < self.lamps.length; ++i) {
                var color = Math.floor(Math.random() * 9);
                if (color < 4) {
                    self.lamps[i].texture = self.lamps_texture[color];
                    self.lamps[i].alpha = 1;
                    self.lamps[i].visible = true;
                }
                else {
                    self.lamps[i].visible = false;
                }
            }
            self.blinkTimeId = setTimeout(function () {
                if (self.iterationCount === 99) {
                    self.iterationCount = 0;
                    hideAllLamps();
                    done();
                }
                else {
                    randomBlink(done);
                }
            }, 50);
        }.bind(this);

        var colorTrains = function (removal, done) {
            var self = this;
            var color = removal;
            for (var i = 0; i < self.lamps.length; ++i) {
                self.lamps[i].alpha = 1;
                if (color < 4) {
                    self.lamps[i].texture = self.lamps_texture[color];
                    self.lamps[i].visible = true;
                }
                else {
                    self.lamps[i].visible = false;
                }
                ++color;
                color = color % 10;
            }
            if (removal > 0) {
                self.trainsTimeId = setTimeout(function () {
                    colorTrains(removal - 1, done);
                }, 50);
            }
            else {
                hideAllLamps();
                done();
            }
        }.bind(this);

        var synchronizedBlink = function (done) {
            var self = this;
            var callback = function () {
                synchronizedBlink(done);
                ++self.iterationCount;
            };
            if (done && self.iterationCount === 2) {
                callback = function () {
                    self.iterationCount = 0;
                    hideAllLamps();
                    done();
                };
            }

            for (var i = 0; i < self.lamps.length; ++i) {
                var on_complete = null;
                self.lamps[i].texture = self.lamps_texture[i % 4];
                self.lamps[i].alpha = 0;
                self.lamps[i].visible = true;
                if (i === self.lamps.length - 1) {
                    on_complete = function () {
                        callback();
                    }.bind(this)
                }
                self.blinkFadeOutTween = new TWEEN.Tween(self.lamps[i])
                    .to({alpha: 0}, 400)
                    .onComplete(on_complete);
                self.blinkFadeInTween = new TWEEN.Tween(self.lamps[i])
                    .to({alpha: 1}, 300)
                    .chain(self.blinkFadeOutTween)
                    .start();
            }
        }.bind(this);

        var snakeWithAlpha = function (index, done) {
            var self = this;
            self.lamps[index].texture = self.lamps_texture[index % 4];
            self.lamps[index].alpha = 1;
            self.lamps[index].visible = true;

            self.snakeTimeId = setTimeout(function () {
                var fadeOutTween = new TWEEN.Tween(self.lamps[index])
                    .to({alpha: 0}, 500)
                    .start();
            }, 500);

            if (self.iterationCount === 2 && index > self.lamps.length - 2) {
                self.iterationCount = 0;
                hideAllLamps();
                done();
            }
            else if (index === self.lamps.length - 1) {
                ++self.iterationCount;
                self.snakeTimeId = setTimeout(function () {
                    snakeWithAlpha(0, done);
                }, 25);
            }
            else {
                self.snakeTimeId = setTimeout(function () {
                    snakeWithAlpha(index + 1, done);
                }, 25);
            }
        }.bind(this);

        self.iterationCount = 0;
        hideAllLamps();
        snakeWithAlpha(0, function () {
            synchronizedBlink(function () {
                colorTrains(self.lamps.length, function () {
                    randomBlink(self.animLamps.bind(self));
                });
            });
        });
    };

    JackpotScene.prototype.flowWinLabel = function (font, time, from, to, done) {
        
        var self = this;

        var win = {value: from};

        if (this.winflowTween) {
            this.winflowTween.stop();
        }

        // var time = 5000;
        // var jp_value = to - from;
        //
        // if (jp_value > 200000)
        //     time = 120 * 1000;
        // else if (jp_value > 100000)
        //     time = 90 * 1000;
        // else if (jp_value > 50000)
        //     time = 60 * 1000;
        // else if (jp_value > 10000)
        //     time = 30 * 1000;
        // else if (jp_value > 5000)
        //     time = 10 * 1000;

        this.winflowTween = new TWEEN.Tween(win)
            .to({value: to}, time * 1000)
            .onUpdate(function () {
                var value = win.value | 0;
                font.text = value.toString();
            })
            .onComplete(function () {
                if (done) done();
            })
            .start();
    };

    JackpotScene.prototype.coinsRain = function (finishY, coins) {
        var self = this;
        this.fallDownTween = [];

        for (var i = 0; i < coins.length; ++i) {
            var falling_time = 20 * getRandomInt(50, 100);
            var wait_time = /*10 * */ 5 * getRandomInt(1, 500);
            var frame = getRandomInt(0, 9);
            coins[i].rotation = getRandomInt(0, 90);
            coins[i].gotoAndPlay(frame);

            (function (k) {
                self.fallDownTween[i] = new TWEEN.Tween(coins[k].position)
                    .delay(wait_time)
                    .to({y: finishY}, falling_time)
                    .onUpdate(function (progress) {
                        if (progress === 1 || coins[k].position.y < -40) {
                            coins[k].visible = false;
                            coins[k].stop();
                            if (self.winflow_ended === true) {
                                if (self.fallDownTween[k]) {
                                    self.fallDownTween[k].stop();
                                    self.fallDownTween[k] = null;
                                }
                            }
                        }
                        else {
                            coins[k].visible = true;
                            coins[k].play();
                        }
                    })
                    .repeat(Infinity)
                    .start();
            }(i));
        }
    };

    JackpotScene.prototype.showYouWonLabel = function () {
        this.youWonLabel.visible = true;
        var fadeInTween = new TWEEN.Tween(this.youWonLabel)
            .to({alpha: 1}, 500)
            .start();
    };

    JackpotScene.prototype.blinkPressStart = function () {
        this.pressCollectLabel.visible = true;
        this.pressCollectLabel.alpha = 0;

        if (this.blinkTween) {
            this.blinkTween.stop();
            this.blinkTween = null;
        }

        this.blinkTween = new TWEEN.Tween(this.pressCollectLabel)
            .to({alpha: 1}, 750)
            .repeat(Infinity)
            .delay(100)
            .yoyo(true)
            .easing(TWEEN.Easing.Cubic.InOut)
            .start();

    };


    global.JackpotScene = JackpotScene;
}(typeof module === 'object' && module.exports || this));


//////////////////
// WEBPACK FOOTER
// ./src/library/jackpot-scene.js
// module id = 68
// module chunks = 0